<template>
  <div class="create-batch-check-order-job">
    <a-spin :spinning="loading">
      <div class="content" style="min-height: 0">
        <a-tabs default-active-key="OrderStatusFlow" @change="changeTabs">
          <a-tab-pane
            v-if="isEdit"
            key="OrderStatusFlow"
            :tab="$t(`form.OrderStatusFlow`)"
          ></a-tab-pane>
          <a-tab-pane key="SupplierInfo" :tab="$t(`供应商信息`)"></a-tab-pane>
          <a-tab-pane key="ReceiverInfo" :tab="$t(`收货信息`)"></a-tab-pane>
          <a-tab-pane key="ArrivalDetail" :tab="$t(`采购信息`)"></a-tab-pane>
          <a-tab-pane key="ProductInfo" :tab="$t(`订单明细`)"></a-tab-pane>
        </a-tabs>
      </div>
      <div class="content-overflow mt10">
        <section class="left-div fixContent" :style="{ height: scrollHeight }">
          <a-form-model ref="ruleForm" :model="formData">
            <div v-if="isEdit" id="OrderStatusFlow" class="modalBox">
              <p>
                <i class="leftLine"></i>
                <span style="font-size: 16px; font-weight: 900; color: rgba(0, 0, 0, 0.85)">
                  {{ $t(`订单流转状态`) }}
                </span>
                <a-icon type="sync" class="text-main" @click="refreshHandle" />
              </p>
              <div class="statusBox">
                <p v-show="formData.purchaseOrderSn">
                  {{ $t(`form.PurchaseOrderNumber`) }}：{{ formData.purchaseOrderSn }}
                  <a-tag style="font-size: 12px; font-weight: normal; margin-left: 10px">
                    {{ $t(`form.${formData.status}`) }}
                  </a-tag>
                </p>
                <div
                  v-if="!isShow && !isInfoShow && formData.status && formData.status !== 'CANCEL'"
                >
                  <a-button
                    v-if="
                      formData.status === 'WAIT_CHECK' &&
                      getPermission(['f_purchase', 'f_purchase_order_audit'])
                    "
                    type="primary"
                    :loading="reviewLoading"
                    @click="onReview"
                  >
                    {{ $t(`form.Review`) }}
                  </a-button>
                  <a-button
                    v-if="
                      formData.status &&
                      (formData.status == 'PART_INBOUD' || formData.status == 'PART_INBOUND')
                    "
                    type="primary"
                    :loading="confirmFinishLoading"
                    @click="onConfirmFinish"
                  >
                    {{ $t(`form.ConfirmFinish`) }}
                  </a-button>
                  <a-button
                    v-if="
                      formData.status &&
                      (formData.status == 'WAIT_CHECK' || formData.status == 'WAIT_INBOUND')
                    "
                    type="danger"
                    :loading="voidOrderLoading"
                    @click="onVoidOrder"
                  >
                    {{ $t(`form.VoidOrder`) }}
                  </a-button>
                  <a-button
                    type="primary"
                    v-if="
                      ['WAIT_INBOUND', 'PART_INBOUND', 'SUPPLIER_PART_SEND_GOODS'].includes(
                        formData.status
                      )
                    "
                    @click="createAdvNotes"
                  >
                    {{ $t(`form.CreateAdvancedShippingNotes`) }}
                  </a-button>
                  <a-button
                    type="danger"
                    v-if="
                      formData.status &&
                      (formData.status == 'PART_INBOUND' || formData.status == 'FINISH')
                    "
                    @click="createReturnOrder"
                  >
                    {{ $t(`采购退货`) }}
                  </a-button>
                  <a-button
                    type="primary"
                    v-if="formData.status !== 'WAIT_CHECK'"
                    @click="showPriceAdjustmentModal"
                  >
                    {{ $t(`供价调整`) }}
                  </a-button>
                </div>
              </div>
              <ProcessState2
                v-if="stateData.length > 0"
                :statedata="stateData"
                :curstate="curState"
                :style-obj="{ stateItem: 130 }"
              />
            </div>
            <div id="SupplierInfo" class="modalBox">
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  <span>{{ $t('供应商信息') }}</span>
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isShow && formData.status !== 'CANCEL'"
                      @click.prevent="isShow = !isShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="createForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="cancelEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                  <span>
                    <a style="font-size: 14px; margin-left: 10px" v-if="isCopy" @click="copyOrder">
                      {{ $t(`复制订单`) }}
                    </a>
                  </span>
                </div>
              </div>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.supplierName`)" :required="true">
                    <a-input v-if="isDisabled" :value="formData.supplierName" disabled />
                    <SelectSupplier
                      v-else
                      ref="selectSupplierRef"
                      :code="formData.supplierCode"
                      @supplierIndexChange="supplierIndexChange"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.OpeningBank`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.openingBank"
                      :placeholder="$t(`form.OpeningBank`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.BankAccount`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.bankAccount"
                      :placeholder="$t(`form.BankAccount`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.ContactInformation`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.supplierMobile"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`form.supplierMobile`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.ShippingAddress`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.supplierAddress"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`form.SupplierShippingAddress`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" v-if="hasFMSApp">
                  <a-form-model-item :label="$t(`结算组织`)" required>
                    <SelectBU
                      :disabled="isDisabled"
                      :code.sync="formData.businessUnitCode"
                      :name.sync="formData.businessUnitName"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
            <div id="ReceiverInfo" class="modalBox">
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  <span>{{ $t('收货信息') }}</span>
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isShow && formData.status !== 'CANCEL'"
                      @click.prevent="isShow = !isShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="createForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="cancelEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                </div>
              </div>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item required :label="$t(`form.receiverWarehouse`)">
                    <SelectWarehouseNew
                      ref="SelectWarehouseRef"
                      :disabled="isDisabled"
                      :code.sync="formData.warehouseCode"
                      @selected="selectedWarehouse"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item required :label="$t(`仓库货主`)">
                    <SelectWarehouseShipper
                      ref="SelectWarehouseShipperRef"
                      :disabled="isDisabled"
                      :wmsAppCode="wmsAppCode"
                      :code.sync="formData.shipperUniqueCode"
                      @selected="changeShipper"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.receiverName`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.receiverName"
                      :placeholder="$t(`form.receiverName`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.receiverMobile`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.receiverMobile"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`form.receiverMobile`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="16">
                  <a-form-model-item :label="$t(`form.receiverAddress`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.receiverAddress"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`form.receiverAddress`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
            <div id="ArrivalDetail" class="modalBox">
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  <span>{{ $t('form.PurchasingInformation') }}</span>
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isShow && formData.status !== 'CANCEL'"
                      @click.prevent="isShow = !isShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="createForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="cancelEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                </div>
              </div>
              <a-row :gutter="24">
                <!-- <a-col :span="8">
                  <a-form-model-item :label="$t(`form.OrderType`)">
                    <a-select
                      allowClear
                      :placeholder="$t(`form.SelectOrderType`)"
                      style="width: 100%"
                      v-model="formData.purchaseOrderType"
                      :disabled="isDisabled"
                    >
                      <a-select-option key="FIRST_ORDER" value="FIRST_ORDER">
                        {{ $t(`form.FIRST_ORDER`) }}
                      </a-select-option>
                      <a-select-option key="REPEAT_ORDER" value="REPEAT_ORDER">
                        {{ $t(`form.REPEAT_ORDER`) }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col> -->
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.referenceNo`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.referenceNo"
                      :placeholder="$t(`form.referenceNo`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item>
                    <template template="label">
                      <a-popover placement="topLeft">
                        <template slot="content">
                          {{ $t('下单时间指的是跟供应商线下的下单时间') }}
                        </template>
                        <div style="line-height: normal">
                          {{ $t(`form.OrderDate`) }}
                          <i class="fa-regular fa-circle-question"></i>
                          :
                        </div>
                      </a-popover>
                    </template>
                    <DatePicker
                      :needhms="true"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.purchaseOrderTime"
                      @choose="chooseOrderDate"
                      :disabled="isDisabled"
                      :placehold="$t(`form.OrderDate`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`预计到货时间`)">
                    <DatePicker
                      :needhms="false"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.estimatedArrivalTime"
                      @choose="chooseEstimatedArrivalTime"
                      :disabled="isDisabled"
                      :placehold="$t(`预计到货时间`)"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item required :label="$t(`form.ProductTotalAmount`)">
                    <PriceInput
                      disabled
                      :currency="tableData[0]?.currency"
                      :value="formData.orderAmount"
                      :placeholder="$t(`form.SumOfTotalAmountOfGoods`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" v-if="isEdit">
                  <a-form-model-item :label="$t(`已退数量`)">
                    <a-input disabled :value="formData.returnedQuantity" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.VATRate`) + '(%)'" required>
                    <div class="flex">
                      <a-input-number
                        style="width: 100%; margin-right: 10px"
                        :disabled="isDisabled"
                        v-model="formData.vatRate"
                        :placeholder="$t(`form.PleaseTheNumericalPart`)"
                        @change="inputVATRateFn"
                      />
                      <a-select
                        allowClear
                        :placeholder="$t(`商品采购价是否含税`)"
                        style="width: 100%"
                        v-model="formData.isItemIncludeTax"
                        @change="changeIncludeTax"
                        :disabled="isDisabled"
                      >
                        <a-select-option :value="1">
                          {{ $t(`采购价格含税`) }}
                        </a-select-option>
                        <a-select-option :value="0">
                          {{ $t(`采购价格不含税`) }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.InvoiceType`)">
                    <a-select
                      allowClear
                      :placeholder="$t(`form.InvoiceType`)"
                      style="width: 100%"
                      v-model="formData.invoiceType"
                      :disabled="isDisabled"
                    >
                      <a-select-option key="VAT_INVOICE" value="VAT_INVOICE">
                        {{ $t(`form.VATSpecialInvoice`) }}
                      </a-select-option>
                      <a-select-option key="ORDINARY_INVOICE" value="ORDINARY_INVOICE">
                        {{ $t(`form.OrdinaryInvoice`) }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.SalesVAT`)">
                    <PriceInput
                      disabled
                      :currency="tableData[0]?.currency"
                      :value="formData.salesVat"
                      :placeholder="$t(`form.SalesVATCalculation`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.OtherFees`)">
                    <PriceInput
                      :currency="tableData[0]?.currency"
                      :disabled="isDisabled"
                      :value.sync="formData.otherFees"
                      :placeholder="$t(`form.OtherFees`)"
                      @blur="inputOtherFeesFn"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`订单总金额（含税）`)">
                    <PriceInput
                      :currency="tableData[0]?.currency"
                      :disabled="isDisabled"
                      :value.sync="formData.totalAmount"
                      :placeholder="$t(`商品总金额+销售增值税+其他费用`)"
                      @blur="inputTotalOrderAmountFn"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8" v-if="isEdit">
                  <a-form-model-item :label="$t(`分期付款`)">
                    <a-input disabled v-model="formData.installments"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" v-if="isEdit">
                  <a-form-model-item :label="$t(`预付款比例`) + '(%)'">
                    <a-input disabled v-model="formData.prepaymentRatio"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`是否包含运费`)">
                    <a-select
                      allowClear
                      style="width: 100%"
                      v-model="formData.freightInfo"
                      :disabled="isDisabled"
                    >
                      <a-select-option value="INCLUDE">
                        {{ $t(`含`) }}
                      </a-select-option>
                      <a-select-option value="EXCLUDE">
                        {{ $t(`不含`) }}
                      </a-select-option>
                      <a-select-option value="GUANGDONG_OR_OTHER_PROVINCE">
                        {{ $t(`广东/其他省`) }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.PORemarks`)">
                    <a-input
                      :disabled="isEdit && (!isEdit || !isShow)"
                      v-model="formData.note"
                      :placeholder="$t(`form.PORemarks`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t('自动化')">
                    <a-select
                      v-model="formData.autoType"
                      :disabled="isDisabled"
                      :placeholder="$t('form.pleaseChoose')"
                      style="width: 100%"
                    >
                      <a-select-option value="none">{{ $t('无') }}</a-select-option>
                      <!-- <a-select-option :disabled="warehouseType === 'PHYSICAL'" value="all">
                        一键采购并入库
                      </a-select-option> -->
                      <a-select-option value="create_asn">
                        {{ $t('创建入库单手动入库') }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-form-model>
          <div id="ProductInfo" class="modalBox">
            <div class="infoTitle">
              <div>
                <i class="leftLine"></i>
                {{ $t('订单明细') }}
                <span>
                  <a
                    style="margin-left: 5px; font-size: 14px"
                    href="javascript:;"
                    v-if="isEdit && !isInfoShow && formData.status === 'WAIT_CHECK'"
                    @click.prevent="isInfoShow = !isInfoShow"
                  >
                    <a-icon type="edit" />
                  </a>
                  <a
                    style="margin: 0 5px; font-size: 14px"
                    href="javascript:;"
                    v-if="isEdit && isInfoShow && formData.status === 'WAIT_CHECK'"
                    @click.prevent="createInfoForm"
                  >
                    <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                  </a>
                  <a
                    style="font-size: 14px"
                    href="javascript:;"
                    v-if="isEdit && isInfoShow && formData.status === 'WAIT_CHECK'"
                    @click.prevent="cancelInfoEdit"
                  >
                    <a-icon type="close-circle" />
                  </a>
                </span>
              </div>
            </div>
            <a-radio-group class="mb8" v-model="detailType" button-style="solid">
              <a-radio-button value="goods">{{ $t('物料明细') }}</a-radio-button>
              <a-radio-button value="paymentPlan">{{ $t('付款计划') }}</a-radio-button>
            </a-radio-group>
            <div v-show="detailType === 'goods'">
              <div class="pricing-method flex-ct">
                <a-form-model-item :label="$t(`计价方式`)" required>
                  <a-select
                    :disabled="isEdit && !isInfoShow"
                    :placeholder="$t(`请选择计价方式`)"
                    v-model="calculateTypeNew"
                    @change="scrollToBottom"
                    style="width: 300px"
                  >
                    <a-select-option value="BY_TOTAL">
                      {{ $t('通过小计计算单价') }}
                    </a-select-option>
                    <a-select-option value="BY_UNIT">
                      {{ $t('通过单价计算小计') }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
              <a-row
                v-if="!isEdit || (isEdit && isInfoShow)"
                style="display: flex; justify-content: space-between"
              >
                <a-col style="position: relative; flex: 1; display: flex; align-items: center">
                  <SearchSku ref="searchSkuRef" style="width: 400px" @selected="handleChangeSku" />
                  <div class="quick-search" v-if="isRent">
                    <a-button
                      type="primary"
                      style="margin-left: 10px"
                      @click="$refs.skuModal.open()"
                    >
                      {{ $t('SKU快捷查询') }}
                    </a-button>
                    <sku-quick-query-modal ref="skuModal" @selected="onSkuSelected" />
                  </div>
                  <a-button type="primary" style="margin-left: 10px" @click="addGoodsToTable">
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t('form.Add') }}
                  </a-button>
                  <a-button type="primary" @click="showModal">
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t(`form.BatchImport`) }}
                  </a-button>
                </a-col>
                <a-col>
                  <div class="flex fz14 flex-ct mr40" style="font-weight: bold">
                    <span class="mr16">{{ $t('批量修改单位') }}</span>
                    <a-select
                      :placeholder="$t(`form.pleaseChoose`)"
                      style="width: 200px"
                      v-model="batchCurrency"
                      @change="handleChangeAllCurrency"
                    >
                      <a-select-option :value="item" v-for="item in currencyMap" :key="item">
                        {{ $t(`form.${item}`) }}
                      </a-select-option>
                    </a-select>
                  </div>
                </a-col>
                <a-col>
                  <div class="txt fz16 flex-ct" style="font-weight: bold">
                    <div style="margin-right: 30px">
                      {{ $t('数量合计') }}: {{ purchaseAllQuantity | toThousands }}
                    </div>
                    <div class="flex-ct">
                      <span>{{ $t('金额合计') }}:</span>
                      <PriceInput
                        :currency="tableData[0]?.currency"
                        :showTxt="true"
                        :value="purchaseAllAmount"
                      />
                    </div>
                  </div>
                </a-col>
              </a-row>
              <a-row>
                <div class="table-wrapper" style="margin-top: 10px">
                  <!--每个列的宽度必须比列名总长度大才能使表格所有列对齐，留一个列不设置宽度  :rowSelection="{selectedRowKeys: selectedRowKeys}"-->
                  <a-table
                    :columns="columns"
                    :dataSource="tableData"
                    bordered
                    size="middle"
                    :loading="tableLoading"
                    :pagination="false"
                    :scroll="{ x: 1500 }"
                    :rowKey="(record, index) => index"
                  >
                    <span slot="Category">
                      {{ $t(`form.Category`) }}
                    </span>
                    <span slot="ProductBarcode">
                      {{ $t(`form.ProductBarcode`) }}
                    </span>
                    <span slot="SkuNumber">
                      {{ $t(`form.skuNumber`) }}
                    </span>
                    <span slot="SupplierModelNumber">
                      {{ $t(`form.SupplierModelNumber`) }}
                    </span>
                    <span slot="CommoditySpecification">
                      {{ $t(`form.CommoditySpecification`) }}
                    </span>
                    <span slot="CompositionMaterial">
                      {{ $t(`form.CompositionMaterial`) }}
                    </span>
                    <span slot="BoxSize" class="form-table-heard">
                      {{ $t(`form.BoxSize`) }}
                    </span>
                    <span slot="Unit">
                      {{ $t(`form.Unit`) }}
                    </span>
                    <span slot="onTheWay">
                      {{ $t(`form.onTheWay`) }}
                    </span>
                    <span slot="RetailPrice">
                      {{ $t(`form.RetailPrice`) }}
                    </span>
                    <span slot="Remark">
                      {{ $t(`form.Remark`) }}
                    </span>
                    <span slot="discountAmountTitle">
                      <a-popover placement="topLeft">
                        <template slot="content">
                          {{ $t('当单价乘以数量与小计不等时展示优惠金额') }}
                        </template>
                        {{ $t(`优惠金额`) }}
                        <i class="fa-regular fa-circle-question"></i>
                      </a-popover>
                    </span>
                    <span slot="PurchasePriceCase" class="form-table-heard">
                      {{ $t(`form.PurchasePriceCase`) }}
                    </span>
                    <span slot="Operation">
                      {{ $t(`form.Operation`) }}
                    </span>
                    <span slot="titleValue" class="form-table-heard">
                      {{ $t('form.TotalQuantity') }}
                    </span>
                    <span slot="titleValue2" class="form-table-heard">
                      {{ $t('form.PurchasePrice') }}
                    </span>
                    <span slot="CurrencyUnit" class="form-table-heard">
                      {{ $t('form.CurrencyUnit') }}
                    </span>
                    <span slot="CasesNumber" class="form-table-heard">
                      {{ $t('form.CasesNumber') }}
                    </span>
                    <span slot="PurchaseAmount" class="form-table-heard">
                      {{ $t('form.PurchaseAmount') }}
                    </span>
                    <span slot="LeadTime">
                      {{ $t('form.LeadTime') }}
                    </span>
                    <span slot="no" slot-scope="text, record, index">
                      {{ index + 1 }}
                    </span>
                    <span slot="productName" slot-scope="text, record">
                      <div v-if="record.productName">{{ $t('名称') }}:{{ record.productName }}</div>
                      <div v-if="record.barcode">{{ $t('条码') }}:{{ record.barcode }}</div>
                      <div v-if="record.skuCode">{{ $t('编码') }}:{{ record.skuCode }}</div>
                    </span>
                    <span slot="unit" slot-scope="text, record">
                      <SelectUnit
                        :disabled="!(!isEdit || (isEdit && isInfoShow))"
                        :skuCode="record.skuCode"
                        :list="record.unitList || record.unitVoList"
                        :code.sync="record.unit"
                      />
                    </span>
                    <span slot="caseNumShow" slot-scope="text, record">
                      <div
                        v-html="generateUnitConversions(record.unitList || record.unitVoList)"
                      ></div>
                    </span>
                    <template slot="returnedQuantity" slot-scope="text, record">
                      {{ record.returnedQuantity | toThousands }}
                    </template>
                    <template slot="productStyle" slot-scope="text">
                      {{ text }}
                    </template>
                    <template v-for="col in customRenderList" v-slot:[col]="text, record, index">
                      <div :key="col">
                        <!-- includes 用来判断当前的输入类型 -->
                        <div v-if="!isEdit || (isEdit && isInfoShow)">
                          <a-input-number
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            :formatter="Formatter"
                            :parser="Formatter"
                            v-if="col === 'containerQuantity' || col === 'purchaseQuantity'"
                            :value="text"
                            @blur="(e) => handleChange(e.target.value, col, index)"
                          />
                          <PriceInput
                            :currency="tableData[0]?.currency"
                            :placeholder="$t(`form.PleaseEnter`)"
                            v-else-if="col === 'purchaseUnitPrice'"
                            :disabled="calculateTypeNew === 'BY_TOTAL'"
                            :value="text"
                            @blur="(val) => handleChange(val, col, index)"
                          />
                          <PriceInput
                            :currency="tableData[0]?.currency"
                            :placeholder="$t(`form.PleaseEnter`)"
                            v-else-if="col === 'purchaseAmount'"
                            :disabled="calculateTypeNew === 'BY_UNIT'"
                            :value="text"
                            @blur="(val) => handleChange(val, col, index)"
                          />
                          <a-popover v-else-if="col === 'deliveryTime'" trigger="hover">
                            <template slot="content">
                              <p>{{ $t(`layer.LeadTimeEage`) }}</p>
                            </template>
                            <a-input
                              :read-only="readonlyArr.includes(col)"
                              :placeholder="$t(`form.PleaseEnter`)"
                              :value="text"
                              @change="(e) => handleChange(e.target.value, col, index)"
                            />
                          </a-popover>
                          <a-input
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t('多个串码逗号或者空格隔开')"
                            v-else-if="col === 'imeiList'"
                            :value="text"
                            @change="(e) => handleChange(e.target.value, col, index)"
                          />
                          <a-input
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            v-else-if="inputScopedSlots.includes(col)"
                            :value="text"
                            @change="(e) => handleChange(e.target.value, col, index)"
                          />
                          <a-select
                            :placeholder="$t(`form.pleaseChoose`)"
                            style="display: block"
                            v-else-if="col === 'currency'"
                            :value="text"
                            @change="handleChange($event, col, index)"
                          >
                            <a-select-option :value="item" v-for="item in currencyMap" :key="item">
                              {{ $t(`form.${item}`) }}
                            </a-select-option>
                          </a-select>
                          <a v-else-if="col === 'delect'" @click="onDelect(index)">
                            <a-icon type="delete" style="color: red" />
                          </a>
                          <span v-else>{{ text | toThousands }}</span>
                        </div>
                        <span v-else-if="col === 'currency'">
                          {{ $t(`form.${text}`) }}
                        </span>
                        <span v-else-if="col === 'purchaseUnitPrice' || col === 'purchaseAmount'">
                          <PriceInput
                            :currency="tableData[0]?.currency"
                            :value="text"
                            :showTxt="true"
                          />
                        </span>
                        <span v-else-if="col === 'imeiList'">{{ text }}</span>
                        <span v-else>{{ text | toThousands }}</span>
                      </div>
                    </template>
                  </a-table>
                </div>
              </a-row>
            </div>
            <div v-show="detailType === 'paymentPlan'">
              <div class="table-header flex-ct between pb10">
                <div>
                  <a-popover placement="topLeft">
                    <template slot="content">
                      <div>
                        {{ $t('打开：录入应付比例 (%) ，应付金额根据应付比例 (%) 自动计算；') }}
                      </div>
                      <div>
                        {{ $t('关闭：录入应付金额，应付比例 (%) 根据应付金额自动计算。') }}
                      </div>
                    </template>
                    <span>{{ $t('按比例') }}(%)</span>
                    <i class="fa-regular fa-circle-question ml6 mr20"></i>
                  </a-popover>
                  <a-switch v-model="byPercent" :disabled="isEdit && !isInfoShow" />
                </div>
                <div class="option-btns pr20" v-if="!isEdit || (isEdit && isInfoShow)">
                  <span class="text-link fz16" @click="addPaymentPlan({})">
                    {{ $t('增行') }}
                  </span>
                </div>
              </div>

              <a-table
                :columns="paymentPlanColumns"
                :dataSource="paymentPlanList"
                bordered
                size="middle"
                :pagination="false"
                :rowKey="(record, index) => index"
              >
                <template slot="isPrepay" slot-scope="text, record">
                  <a-checkbox v-model="record.isPrepay" :disabled="isEdit && !isInfoShow" />
                </template>
                <template slot="dueDate" slot-scope="text, record">
                  <DatePicker
                    :needhms="false"
                    style="background-color: #ffffff; width: 100%"
                    :init-date-time="record.dueDate"
                    @choose="
                      (data) => {
                        chooseDueDate(record, data)
                      }
                    "
                    :disabled="isEdit && !isInfoShow"
                  />
                </template>
                <template slot="payableRatio" slot-scope="text, record, index">
                  <a-input-number
                    v-if="byPercent"
                    style="width: 100%"
                    v-model="record.payableRatio"
                    :disabled="isEdit && !isInfoShow"
                    :placeholder="$t('form.PleaseEnter')"
                    @blur="checkLessPercent(record, index)"
                  />
                  <span v-else>{{ text }}</span>
                </template>
                <template slot="payableAmount" slot-scope="text, record, index">
                  <PriceInput
                    :showTxt="byPercent"
                    :currency="tableData[0]?.currency"
                    :value.sync="record.payableAmount"
                    :disabled="isEdit && !isInfoShow"
                    :placeholder="$t('form.PleaseEnter')"
                    @blur="
                      () => {
                        checkLessAmount(record, index)
                      }
                    "
                  />
                </template>
                <template slot="amountWithoutTax" slot-scope="text">
                  <PriceInput :value="text" :showTxt="true" :currency="tableData[0]?.currency" />
                </template>
                <template slot="taxAmount" slot-scope="text">
                  <PriceInput :value="text" :showTxt="true" :currency="tableData[0]?.currency" />
                </template>
                <template slot="action" slot-scope="text, record, index">
                  <a-icon
                    v-if="!(isEdit && !isInfoShow) && paymentPlanList.length > 1"
                    type="delete"
                    style="color: red"
                    @click="deletePaymentPlan(index)"
                  />
                </template>
              </a-table>
            </div>
          </div>
        </section>
        <OperationLog :list="orderActions" />
      </div>

      <div class="content" style="min-height: 0" v-if="!isEdit">
        <a-row type="flex" justify="center">
          <a-col v-if="formData.status !== 'CANCEL'">
            <a-row type="flex" justify="start" :gutter="16">
              <a-button type="default" @click="backForm">{{ $t(`form.Back`) }}</a-button>
              <a-button
                v-if="formData.status !== 'FINISH'"
                type="primary"
                @click="onSubmit"
                :loading="submitLoading"
              >
                {{ $t(`form.Save`) }}
              </a-button>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </a-spin>
    <a-modal
      centered
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      :cancelText="$t(`form.ReturnPOList`)"
      :okText="$t(`创建预到货通知单`)"
      class="modalA"
    >
      <div class="node-modal">{{ $t(`layer.POApproved`) }}，{{ $t(`layer.GoToCreate`) }}</div>
    </a-modal>
    <!-- 导入采购商品信息数据 -->
    <a-modal
      class="importModal"
      v-model="isImportData"
      :title="modalInfo.modalTitle"
      :width="500"
      :footer="null"
    >
      <div class="upload-content">
        <a-upload-dragger
          name="file"
          :data="{ buId: buId }"
          :headers="{ Authorization: sessionId }"
          @change="importData"
          :action="modalInfo.modalUrl + `?language=${this.language_mapping[this.lang]}`"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="cloud-upload" />
          </p>
          <p class="ant-upload-hint">{{ $t('form.DragUpload') }}</p>
        </a-upload-dragger>
        <a
          v-if="modalInfo.xlsDownloadUrl"
          class="text-info mt10"
          download
          :href="modalInfo.xlsDownloadUrl"
        >
          {{ $t('采购商品批量录入模版') }}.xls
        </a>
      </div>
    </a-modal>
    <!-- 供价调整弹窗 -->
    <a-modal
      v-model="priceAdjustmentVisible"
      :title="$t('供价调整')"
      :width="800"
      :confirmLoading="priceAdjustmentLoading"
      @ok="updatePurchaseOrderPrice"
    >
      <div class="modal-content">
        <a-table
          :columns="priceAdjustmentColumns"
          :data-source="priceAdjustmentData"
          :pagination="false"
        >
          <span slot="productName" slot-scope="text, record">
            <div v-if="record.productName">{{ $t('名称') }}:{{ record.productName }}</div>
            <div v-if="record.barcode">{{ $t('条码') }}:{{ record.barcode }}</div>
            <div v-if="record.skuCode">{{ $t('编码') }}:{{ record.skuCode }}</div>
          </span>
          <template slot="purchaseUnitPrice" slot-scope="text, record">
            <a-input-number style="width: 120px" v-model="record.purchaseUnitPrice" :min="0" />
          </template>
        </a-table>
      </div>
    </a-modal>
    <!-- 提醒用户去维护供应商 -->
    <a-modal
      v-model="supplierVisible"
      :title="$t('维护结算组织')"
      :okText="$t('去维护')"
      @ok="goToSupplierDetail"
    >
      <div class="flex-ct">
        <a-icon type="info-circle" class="text-warning fz40 mr20" />
        <div class="modal-content-text fz16">
          {{ $t('请先维护供应商的结算组织的信息，再创建采购订单') }}
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
import SelectSupplier from '@component/selectSupplier'
import { mapState, mapGetters } from 'vuex'
import debounce from '@/common/debounce'
import { add, reserved, divide, multiply, subtract } from '@/common/number'
import { getCookie } from '@/common/cookie'
import ProcessState2 from '@component/processState2'
import SearchSku from '@component/searchSku'
import DatePicker from '@component/datePicker'
import formatter from '@/common/formatter'
import deepClone from '@/common/deepClone'
import OperationLog from '@component/operationLog'
import SelectUnit from '@component/selectUnit'
import { getPermission, toFixedUp } from '@/common'
import SelectWarehouseNew from '@component/selectWarehouseNew'
import SelectWarehouseShipper from '@component/selectWarehouseShipper'
import PriceInput from '@component/priceInput'
import SelectBU from '@component/selectBU'
import SkuQuickQueryModal from '@component/skuQuickQueryModal.vue'
const PURCHASE_DRAFT_SESSION_KEY = 'purchaseDraftFormdata:addPurchase:v1'
const PURCHASE_DRAFT_TTL_MS = 24 * 60 * 60 * 1000 // 草稿过期：24小时
export default {
  name: 'addPurchase',
  components: {
    SelectSupplier,
    ProcessState2,
    SearchSku,
    DatePicker,
    OperationLog,
    SelectUnit,
    SelectWarehouseNew,
    SelectWarehouseShipper,
    PriceInput,
    SelectBU,
    SkuQuickQueryModal,
  },
  data() {
    return {
      isCopy: false,
      loading: false,
      visible: false,
      isEdit: false, //是否是详情页
      isShow: false, //详情页下 待审核的单子 上面三块的编辑状态
      isInfoShow: false, //详情页下 待审核的单子 商品模块的编辑状态
      purchaseOrderId: '',
      data2: [],
      orderActions: [],
      keyword: '',
      // 表格数据
      tableData: [],
      // 每一列的插槽名 - 表格行内编辑用
      customRenderList: [
        'containerQuantity',
        'caseUnit',
        'purchaseQuantity',
        'purchaseUnitPrice',
        'imeiList',
        'currency',
        'note',
        'delect',
        'retailPrice',
        'purchaseAmount',
        'deliveryTime',
        // "skuNumber",
      ],
      // 用来匹配插槽中显示input框
      inputScopedSlots: [
        'containerQuantity',
        'purchaseQuantity',
        'purchaseUnitPrice',
        'imeiList',
        'note',
        'retailPrice',
        'purchaseAmount',
        'deliveryTime',
        'discountAmount',
        // "skuNumber",
      ],
      // 用来匹配插槽中显示select框
      selectScopedSlots: ['caseUnit', 'currency'],
      // 对于某些自动赋值的input框设为 只读
      readonlyArr: [''],
      // 表格loading
      tableLoading: false,
      // 表格选中key
      selectedRowKeys: [],
      provinceList: [],
      formData: {
        purchaseOrderType: undefined,
        warehouseCode: undefined,
        invoiceType: undefined,
        autoType: 'none',
        freightInfo: undefined,
        isItemIncludeTax: 0,
        vatRate: 0,
        shipperUniqueCode: undefined,
        totalAmount: undefined,
        salesVat: undefined,
        businessUnitCode: undefined,
        businessUnitName: undefined,
      },
      selectedGoodsOrGroup: {},
      selectedGoodsOrGroupArray: [],
      currentGood: {},
      data: [],
      selectOptionsLoading: false,
      isImportData: false, //批量导入弹窗
      modalInfo: {
        modalTitle: '',
        modalDesc: '',
        modalUrl: api.batchImportPurchaseOrderItems,
        xlsRequestUrl: '',
        xlsDownloadUrl: '',
      }, //批量导入模板信息
      stateData: [],
      pageNo: 1,
      pageSize: 20,
      pages: '',
      curState: {
        state: 'create',
      },
      language_mapping: {
        zh: 'zh_CN',
        en: 'en_US',
        th: 'th_TH',
      },
      purchaseAllQuantity: 0,
      purchaseAllAmount: 0,
      supplierIndex: undefined,
      submitLoading: false,
      calculateType: 'BY_PCS', //计价方式
      reviewLoading: false,
      confirmFinishLoading: false,
      voidOrderLoading: false,
      priceAdjustmentVisible: false,
      priceAdjustmentLoading: false,
      priceAdjustmentData: [],
      wmsAppCode: undefined,
      calculateTypeNew: 'BY_TOTAL',
      paymentPlanList: [],
      detailType: 'goods',
      byPercent: true,
      supplierVisible: false,
      warehouse_code: undefined,
      warehouseType: undefined,
      batchCurrency: undefined, // 批量修改单位
    }
  },
  activated() {
    if (!this.$route.meta.keepAlive) {
      this.resetHandle()
    }
    this.bindDraftAutoSave()
    this.init()
  },
  deactivated() {
    this.unbindDraftAutoSave()
  },
  beforeDestroy() {
    // qiankun 子应用切换/卸载时，可能不会触发路由离开；这里兜底落盘
    try {
      if (!this.$route.query.id && !this._skipDraftPersistOnce) {
        this.persistDraftToSessionStorage()
      }
    } finally {
      this.unbindDraftAutoSave()
    }
  },
  beforeRouteEnter(to, from, next) {
    // console.log('beforeRouteEnter')
    next((vm) => {
      vm.loading = true
      if (to.meta.clearData) {
        vm.clearData()
        // 清空标志
        to.meta.clearData = false
      }
      vm.init()
    })
  },
  beforeRouteUpdate(to, from, next) {
    // console.log('routerUpdate')
    Object.assign(this.$data, this.$options.data())
    this.$nextTick(() => {
      this.init()
    })
    next()
  },
  beforeRouteLeave(to, from, next) {
    if (!this.$route.query.id) {
      if (this._skipDraftPersistOnce) {
        this._skipDraftPersistOnce = false
      } else {
        this.persistDraftToSessionStorage()
      }
    }
    next()
  },
  computed: {
    ...mapState(['currencyMap', 'goodsTypeMapping']),
    ...mapGetters(['isStore', 'isRent']),
    sessionId() {
      return getCookie('d_session_id')
    },
    lang() {
      return this.$store.state.lang
    },
    buId() {
      return this.$store.getters.partyId
    },
    isDisabled() {
      return this.isEdit && (!this.isEdit || !this.isShow || this.formData.status !== 'WAIT_CHECK')
    },
    columns() {
      let list = [
        {
          title: 'NO',
          align: 'center',
          key: 'NO',
          width: 60,
          scopedSlots: {
            customRender: 'no',
          },
        },
        {
          title: this.$t('商品信息'),
          dataIndex: 'productName',
          width: 200,
          scopedSlots: {
            customRender: 'productName',
          },
        },
        {
          slots: { title: 'CommoditySpecification' },
          align: 'center',
          dataIndex: 'productStyle',
          width: 120,
          scopedSlots: {
            customRender: 'productStyle',
          },
        },
        {
          title: this.$t('箱规'),
          align: 'center',
          dataIndex: 'caseNumShow',
          width: 100,
          scopedSlots: {
            customRender: 'caseNumShow',
          },
        },
        {
          align: 'center',
          dataIndex: 'unit',
          width: 100,
          title: this.$t('单位'),
          scopedSlots: {
            customRender: 'unit',
          },
        },
        {
          title: this.$t('数量'),
          align: 'center',
          dataIndex: 'purchaseQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'purchaseQuantity',
          },
        },
        {
          title: this.$t('单价'),
          align: 'center',
          dataIndex: 'purchaseUnitPrice',
          width: 120,
          scopedSlots: {
            customRender: 'purchaseUnitPrice',
          },
        },
        {
          title: this.$t('小计'),
          align: 'center',
          dataIndex: 'purchaseAmount',
          width: 120,
          scopedSlots: {
            customRender: 'purchaseAmount',
          },
        },
        {
          align: 'center',
          dataIndex: 'discountAmount',
          width: 120,
          slots: { title: 'discountAmountTitle' },
          scopedSlots: {
            customRender: 'discountAmount',
          },
        },
        {
          title: this.$t('商品类型'),
          align: 'center',
          dataIndex: 'productType',
          width: 100,
          customRender: (text) => this.goodsTypeMapping[text],
        },
        ...(this.isRent
          ? [
              {
                title: this.$t('IMEI列表'),
                align: 'center',
                dataIndex: 'imeiList',
                width: 220,
                scopedSlots: {
                  customRender: 'imeiList',
                },
              },
            ]
          : []),
        {
          align: 'center',
          dataIndex: 'currency',
          width: 150,
          slots: { title: 'CurrencyUnit' },
          scopedSlots: {
            customRender: 'currency',
          },
        },
        {
          slots: { title: 'SkuNumber' },
          align: 'center',
          dataIndex: 'skuNumber',
          width: 120,
          scopedSlots: {
            customRender: 'skuNumber',
          },
        },
        {
          slots: { title: 'Category' },
          align: 'center',
          dataIndex: 'productCategory',
          width: 120,
          scopedSlots: {
            customRender: 'category',
          },
        },
        {
          slots: { title: 'SupplierModelNumber' },
          align: 'center',
          dataIndex: 'supplierSkuCode',
          width: 120,
          scopedSlots: {
            customRender: 'supplierSkuCode',
          },
        },
        {
          slots: { title: 'CompositionMaterial' },
          align: 'center',
          dataIndex: 'materialQuality',
          width: 120,
          scopedSlots: {
            customRender: 'materialQuality',
          },
        },
        {
          slots: { title: 'Remark' },
          align: 'center',
          dataIndex: 'note',
          width: 120,
          scopedSlots: {
            customRender: 'note',
          },
        },
        {
          slots: { title: 'LeadTime' },
          align: 'center',
          dataIndex: 'deliveryTime',
          width: 120,
          scopedSlots: {
            customRender: 'deliveryTime',
          },
        },
        {
          slots: { title: 'Operation' },
          align: 'center',
          dataIndex: 'delect',
          width: 120,
          scopedSlots: {
            customRender: 'delect',
          },
        },
      ]

      if (this.isEdit && !this.isInfoShow) {
        list.splice(-1, 1, {
          slots: { title: 'onTheWay' },
          align: 'center',
          dataIndex: 'inTransitCount',
          width: 120,
        })
      }
      if (this.isEdit) {
        const index = list.findIndex((item) => item.dataIndex === 'discountAmount')
        if (index > -1) {
          list.splice(index, 0, {
            title: this.$t('已退数量'),
            align: 'center',
            dataIndex: 'returnedQuantity',
            width: 120,
            scopedSlots: {
              customRender: 'returnedQuantity',
            },
          })
        }
      }
      if (!this.isStore) {
        list.splice(3, 2)
      }
      return list
    },
    priceAdjustmentColumns() {
      return [
        {
          title: this.$t('商品信息'),
          dataIndex: 'productName',
          scopedSlots: {
            customRender: 'productName',
          },
        },
        {
          title: this.$t('单价'),
          dataIndex: 'purchaseUnitPrice',
          scopedSlots: {
            customRender: 'purchaseUnitPrice',
          },
        },
      ]
    },
    paymentPlanColumns() {
      return [
        {
          title: this.$t('是否预付'),
          dataIndex: 'isPrepay',
          scopedSlots: {
            customRender: 'isPrepay',
          },
          align: 'center',
          width: 120,
        },
        {
          title: this.$t('到期日'),
          dataIndex: 'dueDate',
          width: 180,
          scopedSlots: {
            customRender: 'dueDate',
          },
        },
        {
          title: this.$t('应付比例') + '(%)',
          dataIndex: 'payableRatio',
          scopedSlots: {
            customRender: 'payableRatio',
          },
          width: 180,
        },
        {
          title: this.$t('应付金额'),
          dataIndex: 'payableAmount',
          scopedSlots: {
            customRender: 'payableAmount',
          },
          width: 180,
        },
        {
          title: this.$t('商品总金额(不含税)'),
          dataIndex: 'amountWithoutTax',
          scopedSlots: {
            customRender: 'amountWithoutTax',
          },
        },
        {
          title: this.$t('税率') + '(%)',
          dataIndex: 'taxRate',
          scopedSlots: {
            customRender: 'taxRate',
          },
        },
        {
          title: this.$t('税额'),
          dataIndex: 'taxAmount',
          scopedSlots: {
            customRender: 'taxAmount',
          },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ]
    },
    scrollHeight() {
      let height = window.innerHeight - (this.isEdit ? 220 : 300)
      return height * this.$store.state.rate + 'px'
    },
    hasFMSApp() {
      let currentIdaasApp = JSON.parse(localStorage.getItem('currentIdaasApp') || '{}')
      return !!currentIdaasApp['FMS']
    },
  },
  methods: {
    Formatter: formatter,
    getPermission,
    formatImeiList(value) {
      if (value === undefined || value === null) return ''
      const s = String(value).trim()
      if (!s) return ''
      // 允许用逗号 / 中文逗号 / 空格分隔，提交统一转成空格分隔
      return s.split(/[,\s，]+/).filter(Boolean)
    },
    buildPurchaseOrderItemReqVOS() {
      if (!this.isRent) return this.tableData
      return this.tableData.map((item) => ({
        ...item,
        imeiList: this.formatImeiList(item.imeiList),
      }))
    },
    clearData() {
      Object.assign(this.$data, this.$options.data())
    },
    resetHandle() {
      this.clearData()
      this.$nextTick(() => {
        this.$refs.searchSkuRef.clear()
        this.$refs.selectSupplierRef?.clear()
        this.$refs.SelectWarehouseRef.clear()
        this.$refs.SelectWarehouseShipperRef.clear()
      })
    },
    bindDraftAutoSave() {
      if (this._draftAutoSaveBound) return
      this._draftAutoSaveBound = true

      this._beforeUnloadHandler = () => {
        if (this._skipDraftPersistOnce) return
        this.persistDraftToSessionStorage()
      }

      this._visibilityHandler = () => {
        if (document.hidden && !this._skipDraftPersistOnce) {
          this.persistDraftToSessionStorage()
        }
      }

      window.addEventListener('beforeunload', this._beforeUnloadHandler)
      document.addEventListener('visibilitychange', this._visibilityHandler)
    },
    unbindDraftAutoSave() {
      if (!this._draftAutoSaveBound) return
      this._draftAutoSaveBound = false
      window.removeEventListener('beforeunload', this._beforeUnloadHandler)
      document.removeEventListener('visibilitychange', this._visibilityHandler)
    },
    persistDraftToSessionStorage() {
      // 只针对“创建采购单”（无 id）保存草稿
      if (this.$route.query.id) return
      if (this._skipDraftPersistOnce) return

      try {
        // 用 tableData 再推导一次金额，尽量保证草稿一致性
        if (Array.isArray(this.tableData) && this.tableData.length) {
          this.getTheAmountInPcFn()
        }

        const payload = {
          version: 1,
          formData: this.formData,
          tableData: this.tableData,
          paymentPlanList: this.paymentPlanList,
          extras: {
            isShow: this.isShow,
            isInfoShow: this.isInfoShow,
            detailType: this.detailType,
            byPercent: this.byPercent,
            calculateTypeNew: this.calculateTypeNew,
            calculateType: this.calculateType,
            wmsAppCode: this.wmsAppCode,
            warehouse_code: this.warehouse_code,
            warehouseType: this.warehouseType,
            batchCurrency: this.batchCurrency,
          },
          updatedAt: Date.now(),
        }

        localStorage.setItem(PURCHASE_DRAFT_SESSION_KEY, JSON.stringify(payload))
      } catch (e) {
        // ignore: 草稿保存失败不应影响用户离开
      }
    },
    clearPurchaseDraft() {
      try {
        localStorage.removeItem(PURCHASE_DRAFT_SESSION_KEY)
      } catch (e) {
        // ignore
      }
    },
    init() {
      this.isShow = false
      this.getDetailInfo()
    },
    changeIncludeTax(val) {
      if (val) {
        this.formData.orderAmount = reserved(
          this.purchaseAllAmount / (1 + (this.formData.vatRate || 0) / 100)
        )
        this.formData.salesVat = reserved(this.purchaseAllAmount - this.formData.orderAmount)
      } else {
        this.formData.salesVat = (
          (this.purchaseAllAmount * (this.formData.vatRate || 0)) /
          100
        ).toFixed(4)
        this.formData.orderAmount = this.purchaseAllAmount
      }
      this.setTotalAmount()
    },
    refreshHandle() {
      this.getDetailInfo()
    },
    scrollToBottom() {
      this.$nextTick(() => {
        document.querySelector('.fixContent').scrollTo(0, 2000)
      })
    },
    setTotalAmount() {
      let otherFees = this.formData.otherFees
      otherFees = otherFees === undefined ? 0 : this.formData.otherFees * 1
      let result = this.formData.orderAmount * 1 + this.formData.salesVat * 1 + otherFees
      this.formData.totalAmount = isNaN(result) ? '' : result.toFixed(4)
      this.calPaymentPlan()
    },
    supplierIndexChange(val) {
      this.formData.supplierCode = val.supplierCode
      // if (this.hasFMSApp && !val.businessUnitCode && !this.$route.query.id) {
      //   this.supplierVisible = true
      //   return
      // }
      this.formData.supplierName = val.supplierName
      this.formData.supplierAddress = val.supplierAddress
      this.formData.supplierMobile = val.supplierMobile
      this.formData.bankAccount = val.bankAccount
      this.formData.openingBank = val.openingBank
      this.formData.businessUnitCode = val.businessUnitCode || this.formData.businessUnitCode
      this.formData.businessUnitName = val.businessUnitName || this.formData.businessUnitName
      this.$forceUpdate()
      // 获取供应商详情，回显付款计划设置
      if (val.supplierCode) {
        http({
          url: api.supplierDetail,
          type: 'post',
          data: { supplierCode: val.supplierCode },
          success: (res) => {
            const settings = res?.result?.paymentPlanSettings
            if (Array.isArray(settings) && settings.length > 0) {
              // 清空现有付款计划，用供应商配置初始化
              this.paymentPlanList = []
              settings.forEach((item) => {
                this.addPaymentPlan({ ratio: item.ratio, isPrepay: item.isPrepay })
              })
              // 设置 isPrepay 字段（addPaymentPlan 只接受 ratio/amount，需单独赋值）
              settings.forEach((item, idx) => {
                if (this.paymentPlanList[idx] !== undefined) {
                  this.$set(this.paymentPlanList[idx], 'isPrepay', item.isPrepay === 1)
                }
              })
            }
          },
        })
      }
    },
    async getDetailInfo() {
      this.loading = true
      this.isCopy = false
      let purchaseFormdata = localStorage.getItem('purchaseFormdata')
      if (this.$route.query.id) {
        this.clearPurchaseDraft()
        this.isCopy = true
        this.purchaseOrderId = this.$route.query.id
        this.getOrderActionList()
        this.isEdit = true
        let res = await http({
          url: api.purchaseOrderDetail,
          type: 'post',
          data: {
            purchaseOrderId: this.purchaseOrderId,
          },
        })
        let goodsList = res.result.purchaseOrderItemResVOS.sort((a, b) => {
          a.skuNumber - b.skuNumber
        })
        goodsList.forEach((goodsItem) => {
          if (goodsItem.deliveryTime) {
            goodsItem.deliveryTime = goodsItem.deliveryTime.split(' ')[0]
          }
          goodsItem.unit = goodsItem.caseUnit
          if (this.isRent && Array.isArray(goodsItem.imeiList)) {
            goodsItem.imeiList = goodsItem.imeiList.join(' ')
          }
        })
        this.tableData = goodsList
        let formData = res.result
        formData.isItemIncludeTax = +formData.isItemIncludeTax
        this.formData = formData
        this.calculateType = formData.calculateType
        this.paymentPlanList = formData.paymentPlanList.map((item) => ({
          ...item,
          isPrepay: Boolean(item.isPrepay),
        }))
        this.keyword = ''
        this.$forceUpdate()
        this.getOrderProcess()
        this.calcAllAmount()
      } else if (purchaseFormdata) {
        let data = JSON.parse(purchaseFormdata)
        this.formData = data
        this.formData.status = ''
        this.tableData = deepClone(this.formData.tableData)
        this.paymentPlanList = deepClone(this.formData.paymentPlanList)
        const extras = this.formData._draftExtras || {}
        this.detailType = extras.detailType || this.detailType
        this.byPercent = extras.byPercent !== undefined ? extras.byPercent : this.byPercent
        this.calculateTypeNew = extras.calculateTypeNew || this.calculateTypeNew
        this.calculateType = extras.calculateType || this.calculateType
        this.isShow = extras.isShow !== undefined ? extras.isShow : this.isShow
        this.isInfoShow = extras.isInfoShow !== undefined ? extras.isInfoShow : this.isInfoShow
        this.wmsAppCode = extras.wmsAppCode !== undefined ? extras.wmsAppCode : this.wmsAppCode
        this.warehouse_code =
          extras.warehouse_code !== undefined ? extras.warehouse_code : this.warehouse_code
        this.warehouseType =
          extras.warehouseType !== undefined ? extras.warehouseType : this.warehouseType
        this.batchCurrency =
          extras.batchCurrency !== undefined ? extras.batchCurrency : this.batchCurrency
        delete this.formData.tableData
        delete this.formData.paymentPlanList
        delete this.formData._draftExtras
        localStorage.removeItem('purchaseFormdata')

        // 兜底修复：恢复后重新计算用于页面展示的数据
        this.calcAllAmount()
        this.setTotalAmount()
      } else {
        const purchaseDraft = localStorage.getItem(PURCHASE_DRAFT_SESSION_KEY)
        if (purchaseDraft) {
          const payload = JSON.parse(purchaseDraft)
          const updatedAt = payload.updatedAt || 0
          if (updatedAt && Date.now() - updatedAt > PURCHASE_DRAFT_TTL_MS) {
            this.clearPurchaseDraft()
            this.loading = false
            return
          }
          this.formData = payload.formData || {}
          this.formData.status = ''
          this.tableData = deepClone(payload.tableData || [])
          this.paymentPlanList = deepClone(payload.paymentPlanList || [])

          const extras = payload.extras || {}
          this.isShow = extras.isShow !== undefined ? extras.isShow : this.isShow
          this.isInfoShow = extras.isInfoShow !== undefined ? extras.isInfoShow : this.isInfoShow
          this.detailType = extras.detailType || this.detailType
          this.byPercent = extras.byPercent !== undefined ? extras.byPercent : this.byPercent
          this.calculateTypeNew = extras.calculateTypeNew || this.calculateTypeNew
          this.calculateType = extras.calculateType || this.calculateType
          this.wmsAppCode = extras.wmsAppCode !== undefined ? extras.wmsAppCode : this.wmsAppCode
          this.warehouse_code =
            extras.warehouse_code !== undefined ? extras.warehouse_code : this.warehouse_code
          this.warehouseType =
            extras.warehouseType !== undefined ? extras.warehouseType : this.warehouseType
          this.batchCurrency =
            extras.batchCurrency !== undefined ? extras.batchCurrency : this.batchCurrency

          localStorage.removeItem(PURCHASE_DRAFT_SESSION_KEY)

          // 兜底修复：恢复后重新计算用于页面展示的数据
          this.calcAllAmount()
          this.setTotalAmount()
        }
      }
      this.loading = false
    },
    createForm() {
      let formData = deepClone(this.formData)
      http({
        url: api.updatePurchaseOrderInfo,
        type: 'post',
        data: {
          ...formData,
        },
        hasLoading: false,
        success: () => {
          this.getOrderActionList()
          http({
            instance: this,
            url: api.purchaseOrderDetail,
            type: 'post',
            data: {
              purchaseOrderId: this.purchaseOrderId,
            },
            success: () => {
              this.getDetailInfo()
              this.$forceUpdate()
              this.getOrderProcess()
            },
          })
          this.isShow = !this.isShow
        },
      })
    },
    async createInfoForm() {
      await this.verification()
      await http({
        url: api.updatePurchaseOrderItems,
        type: 'post',
        data: {
          calculateType: this.calculateType,
          orderAmount: this.formData.orderAmount,
          salesVat: this.formData.salesVat,
          totalAmount: this.formData.totalAmount,
          purchaseOrderId: this.purchaseOrderId,
          purchaseOrderItemReqVOS: this.buildPurchaseOrderItemReqVOS(),
          paymentPlanList: this.paymentPlanList,
        },
        hasLoading: false,
      })
      this.getDetailInfo()
      this.isInfoShow = !this.isInfoShow
    },
    cancelEdit() {
      this.getDetailInfo()
      this.isShow = !this.isShow
    },
    cancelInfoEdit() {
      this.getDetailInfo()
      this.isInfoShow = !this.isInfoShow
    },
    getOrderActionList() {
      http({
        url: api.purchaseOrderActionList,
        type: 'post',
        data: {
          purchaseOrderId: this.purchaseOrderId,
        },
        hasLoading: false,
        success: (res) => {
          this.orderActions = res.result
        },
      })
    },
    chooseEstimatedArrivalTime(data) {
      this.formData.estimatedArrivalTime = data.data
    },
    chooseOrderDate(data) {
      this.formData.purchaseOrderTime = data.data
    },
    handleChangeSku(data) {
      this.currentGood = data
    },
    handleChange(value, colName, index) {
      const newData = [...this.tableData]
      const target = newData[index]
      if (target) {
        target[colName] = value
        this.calcPurchaseAmount(colName)
        this.tableData = newData
      }
    },
    calcPurchaseAmount(colName) {
      this.getTheAmountInPcFn(colName)
      this.calcAllAmount()
    },
    calcAllAmount() {
      let quantity = 0,
        amount = 0
      this.tableData.forEach((item) => {
        quantity = add(quantity, item.purchaseQuantity)
        amount = add(amount, item.purchaseAmount)
      })
      this.purchaseAllQuantity = quantity
      this.purchaseAllAmount = amount
    },
    onDelect(index) {
      this.tableData.splice(index, 1)
      this.$nextTick(() => {
        this.calcPurchaseAmount()
      })
    },
    addGoodsToTable() {
      if (this.currentGood.skuName) {
        this.currentGood.productCategory =
          this.currentGood.categoryName || this.currentGood.category //类目
        this.currentGood.productName = this.currentGood.skuName
        this.currentGood.skuNumber = this.currentGood.brandSku //品牌款号
        this.currentGood.supplierSkuCode = this.currentGood.supplierSku //供应商款号
        this.currentGood.productStyle = this.currentGood.skuStyleValue
        this.currentGood.materialQuality = this.currentGood.compositionOrMaterial //成分材质
        this.currentGood.productType = this.currentGood.goodsType //商品类型
        let procurementUnitItem =
            this.currentGood.unitList?.find((item) => item.procurementUnit) || {},
          baseUnitItem = this.currentGood.unitList?.find((item) => item.baseUnit) || {}
        this.currentGood.unit = procurementUnitItem.unitNameFull || baseUnitItem.unitNameFull
        this.currentGood.currency = 'CNY'
        this.currentGood.editable = true
        this.currentGood.purchaseQuantity = ''
        this.currentGood.purchaseUnitPrice = ''
        this.currentGood.purchaseAmount = ''
        if (this.isRent && Array.isArray(this.currentGood.imeiList)) {
          this.currentGood.imeiList = this.currentGood.imeiList.join(' ')
        }
        if (
          this.tableData.length &&
          this.tableData.findIndex((i) => i.barcode == this.currentGood.barcode) !== -1
        ) {
          return this.$message.error(this.$t('form.DoNotAddRepeatedly'))
        }
        this.tableData.push(this.currentGood)
        this.scrollToBottom()
      }
    },
    // 以pc获取金额
    getTheAmountInPcFn() {
      if (!this.tableData.length) return
      let hasEmpty = false
      let sum = 0
      this.tableData.forEach((item) => {
        // console.log('item', item)
        if (
          item.purchaseQuantity &&
          (String(item.purchaseUnitPrice) || String(item.purchaseAmount))
        ) {
          //修改单价和数量 小计跟着改
          if (this.calculateTypeNew === 'BY_TOTAL') {
            item.purchaseUnitPrice = toFixedUp(
              divide(item.purchaseAmount, item.purchaseQuantity),
              4
            )
          } else {
            item.purchaseAmount = multiply(item.purchaseUnitPrice, item.purchaseQuantity).toFixed(4)
          }
          sum += item.purchaseAmount * 1

          let calTotalAmount = item.purchaseQuantity * item.purchaseUnitPrice
          item.discountAmount = (calTotalAmount - item.purchaseAmount).toFixed(4)
        } else {
          hasEmpty = true
        }
      })
      if (hasEmpty) return
      if (this.formData.isItemIncludeTax) {
        this.formData.orderAmount = reserved(sum / (1 + (this.formData.vatRate || 0) / 100))
        this.formData.salesVat = reserved(sum - this.formData.orderAmount)
      } else {
        this.formData.salesVat = ((sum * (this.formData.vatRate || 0)) / 100).toFixed(4)
        this.formData.orderAmount = sum.toFixed(4)
      }
      this.setTotalAmount()
    },
    // 输入增值税率
    inputVATRateFn: debounce(function () {
      let result = 0
      if (this.formData.isItemIncludeTax) {
        this.formData.orderAmount = reserved(
          this.purchaseAllAmount / (1 + this.formData.vatRate / 100)
        )
        result = reserved(this.purchaseAllAmount - this.formData.orderAmount)
      } else {
        result = ((this.purchaseAllAmount * this.formData.vatRate) / 100).toFixed(4)
      }
      this.formData.salesVat = isNaN(result) ? '' : result
      this.setTotalAmount()
    }),
    // 输入其他费用
    inputOtherFeesFn: debounce(function () {
      this.setTotalAmount()
    }),
    // 输入销售增值税
    inputSalesVATeFn: debounce(function (val) {
      let tempObj = { ...this.formData }
      tempObj.salesVat = val.target.value
      this.formData = { ...tempObj }
      this.setTotalAmount()
    }),
    // 输入订单总金额
    inputTotalOrderAmountFn: debounce(function (val) {
      let tempObj = { ...this.formData }
      tempObj.totalAmount = val
      this.formData = { ...tempObj }
      this.calPaymentPlan()
    }),
    verification() {
      this.tableData.forEach((res) => {
        if (
          res.purchaseUnitPrice === undefined ||
          res.purchaseUnitPrice === '' ||
          res.purchaseAmount === undefined ||
          res.purchaseAmount === ''
        ) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t(`请输入单价、小计`),
          })
          throw Error()
        }
        if (!res.purchaseQuantity) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t(`layer.PleaseQuantity`),
          })
          throw Error()
        }
        if (res.deliveryTime && !/^\d{4}\-\d{2}\-\d{2}$/.test(res.deliveryTime.trim())) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t(`layer.FormatOfLeadTime`),
          })
          throw Error()
        }
      })
      if (this.paymentPlanList.length > 0) {
        this.paymentPlanList.forEach((item) => {
          if (item.payableAmount === undefined) {
            this.$warning({
              title: this.$t(`layer.Warning`),
              content: this.$t(`请输入应付金额与比例`),
            })
            throw Error()
          }
        })
      }
      return Promise.resolve()
    },
    onSubmit: debounce(async function () {
      if (!this.formData.supplierName) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.PleaseSupplier`),
        })
        return
      }
      if (!this.formData.warehouseCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.PleaseReceivingWarehouse`),
        })
        return
      }
      if (this.formData.vatRate === undefined || this.formData.vatRate === null) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`请填写增值税税率`),
        })
        return
      }
      if (this.tableData.length === 0) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`请添加商品`),
        })
        return
      }
      if (this.hasFMSApp && !this.formData.businessUnitCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`请选择结算组织`),
        })
        return
      }
      await this.verification()
      if (this.purchaseOrderId) {
        this.updatePurchaseOrderInfo(this.formData)
        this.updatePurchaseOrderItems()
      } else {
        const data = deepClone(this.formData)
        data.buId = this.$store.getters.partyId
        data.calculateType = this.calculateType
        data.purchaseOrderItemReqVOS = this.buildPurchaseOrderItemReqVOS()
        data.purchaseOrderId = this.purchaseOrderId
        data.isItemIncludeTax = Boolean(data.isItemIncludeTax)
        data.paymentPlanList = this.paymentPlanList
        this.submitLoading = true
        await http({
          instance: this,
          url: api.purchaseOrderSave,
          data,
          type: 'post',
          hasLoading: true,
          success: (res) => {
            if (res.success) {
              const { asnId } = res.result || {}
              this.$success({
                title: this.$t(`layer.Success`),
                content: this.$t(`layer.SavingSucceeded`),
              })
              if (asnId) {
                this._skipDraftPersistOnce = true
                this.clearPurchaseDraft()
                this.$router.push({
                  name: 'advancedShippingNoteDetail',
                  query: { id: asnId },
                })
              } else {
                this._skipDraftPersistOnce = true
                this.clearPurchaseDraft()
                this.resetHandle()
                this.backForm()
              }
            } else {
              this.$error({
                title: this.$t(`layer.Error`),
                content: this.$t(`layer.CreateFailed`),
              })
            }
          },
        })
        this.submitLoading = false
      }
    }),
    updatePurchaseOrderInfo(data) {
      data.purchaseOrderId = this.purchaseOrderId
      http({
        instance: this,
        url: api.updatePurchaseOrderInfo,
        data,
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.purchaseOrderId) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.SavingSucceeded`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.getOrderActionList()
        },
      })
    },
    updatePurchaseOrderItems() {
      http({
        instance: this,
        url: api.updatePurchaseOrderItems,
        data: {
          purchaseOrderId: this.purchaseOrderId,
          purchaseOrderItemReqVOS: this.buildPurchaseOrderItemReqVOS(),
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.purchaseOrderId) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.SavingSucceeded`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.getOrderActionList()
        },
      })
    },
    handleCancel() {
      this.visible = false
      this.backForm()
    },
    handleOk() {
      this.visible = false
      this.$router.push({
        path: '/addAdvancedShippingNote',
        query: {
          purchaseOrderId: this.purchaseOrderId,
        },
      })
    },
    async onReview() {
      this.reviewLoading = true
      await http({
        instance: this,
        url: api.purchaseOrderCheck,
        data: {
          purchaseOrderId: this.purchaseOrderId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.purchaseOrderId) {
            this.visible = true
            this.formData.status = res.result.status
            this.getOrderProcess()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.getOrderActionList()
        },
      })
      this.reviewLoading = false
    },
    async onConfirmFinish() {
      this.confirmFinishLoading = true
      await http({
        instance: this,
        url: api.purchaseOrderFinish,
        data: {
          purchaseOrderId: this.purchaseOrderId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.purchaseOrderId) {
            this.getOrderProcess()
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.OrderClosed`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.getOrderActionList()
        },
      })
      this.confirmFinishLoading = false
    },
    async onVoidOrder() {
      this.voidOrderLoading = true
      await http({
        instance: this,
        url: api.purchaseOrderCancel,
        data: {
          purchaseOrderId: this.purchaseOrderId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.purchaseOrderId) {
            this.getOrderProcess()
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.OrderVoided`),
            })
            this.$route.params.status = 'Cancel'
            this.backForm()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.getOrderActionList()
        },
      })
      this.voidOrderLoading = false
    },
    createAdvNotes() {
      this.$router.push({
        path: '/addAdvancedShippingNote',
        query: {
          purchaseOrderId: this.purchaseOrderId,
        },
      })
    },
    createReturnOrder() {
      this.$router.push({
        path: '/addPurchaseReturn',
        query: {
          purchaseOrderId: this.purchaseOrderId,
        },
      })
    },
    backForm() {
      this.$router.push({ name: 'purchaseList' })
    },
    // 数组对象根据barcode去重方法
    arrayUnique(arr, barcode) {
      var hash = {}
      return arr.reduce(function (acc, cru, index) {
        if (!hash[cru[barcode]]) {
          hash[cru[barcode]] = { index: index }
          acc.push(cru)
        } else {
          acc.splice(hash[cru[barcode]]['index'], 1, cru)
        }
        return acc
      }, [])
    },
    showModal() {
      this.isImportData = true
      this.modalInfo.xlsDownloadUrl =
        this.$i18n.locale == 'zh'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseOrder/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E9%87%87%E8%B4%AD%E5%8D%95%E6%98%8E%E7%BB%86%E6%A8%A1%E6%9D%BF20230411.xlsx'
          : this.$i18n.locale == 'en'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseOrder/PurchaseOrderDetailBatchImportTemplate202304112.xlsx'
          : this.$i18n.locale == 'th'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseOrder/PurchaseOrderDetailBatchImportTemplate202304112.xlsx'
          : ''
    },
    // 导入商品信息数据
    importData(info) {
      this.loading = true
      const status = info.file.status
      if (status === 'done') {
        if (info.file.response.success) {
          // 导入的数据
          let resultArr = info.fileList[info.fileList.length - 1].response.result.items
          let sum = 0
          resultArr.forEach((item) => {
            if (!item.purchaseAmount) {
              item.purchaseAmount = multiply(item.purchaseUnitPrice, item.purchaseQuantity).toFixed(
                4
              )
            }
            if (this.isRent && Array.isArray(item.imeiList)) {
              item.imeiList = item.imeiList.join(' ')
            }
            sum += item.purchaseAmount * 1
          })
          // push到表格列表中
          this.tableData.push(...resultArr)
          let newData = [...this.tableData]
          this.tableData = [...this.arrayUnique(newData, 'barcode')]
          this.formData.purchaseOrderItemReqVOS = this.tableData
          this.isInfoShow = true
          this.formData.orderAmount = sum.toFixed(4)
          let results = ((sum.toFixed(4) * this.formData.vatRate) / 100).toFixed(4)
          this.formData.salesVat = isNaN(results) ? '' : results
          let result = this.formData.orderAmount * 1 + this.formData.salesVat * 1
          this.formData.totalAmount = isNaN(result) ? '' : result.toFixed(4)
          this.$success({
            title: this.$t(`layer.Success`),
            content: `${info.file.name} file uploaded successfully.`,
          })
          this.$nextTick(() => {
            this.loading = false
            this.calcPurchaseAmount()
            this.scrollToBottom()
          })
        } else {
          this.$error({
            title: this.$t(`layer.Error`),
            content: `${info.file.response.msg} file upload failed.`,
          })
          this.loading = false
        }
      } else if (status === 'error') {
        this.$error({
          title: this.$t(`layer.Error`),
          content: `${info.file.name} file upload failed.`,
        })
        this.loading = false
      }
      this.isImportData = false
    },
    getOrderProcess() {
      this.stateData = [
        {
          state: 'create',
          name: 'Create', //创建
          time: this.formData.orderTime,
        },
        {
          state: 'check',
          name: 'Review', //审核
          time: this.formData.status == undefined ? '' : this.formData.checkTime,
        },
        {
          state: 'Warehousing',
          name: 'Warehousing', //入库
          time: this.formData.status == undefined ? '' : this.formData.arrivalTime,
        },
        {
          state: 'Complete',
          name: 'Complete', //完成
          time: this.formData.finishTime,
        },
      ]

      if (this.formData.status === 'CANCEL') {
        this.curState = {
          state: '',
        }
      } else if (['SUPPLIER_PART_SEND_GOODS', 'WAIT_INBOUND'].includes(this.formData.status)) {
        this.curState = {
          state: 'check',
        }
      } else if (this.formData.status === 'PART_INBOUND') {
        this.curState = {
          state: 'Warehousing',
        }
        this.stateData[this.stateData.length - 1].time = ''
      } else if (this.formData.status === 'FINISH') {
        this.curState = {
          state: 'Complete',
        }
      }
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    copyOrder() {
      this.loading = true
      this._skipDraftPersistOnce = true
      this.clearPurchaseDraft()
      this.formData.tableData = this.tableData
      this.formData.paymentPlanList = this.paymentPlanList
      this.formData._draftExtras = {
        isShow: this.isShow,
        isInfoShow: this.isInfoShow,
        detailType: this.detailType,
        byPercent: this.byPercent,
        calculateTypeNew: this.calculateTypeNew,
        calculateType: this.calculateType,
        wmsAppCode: this.wmsAppCode,
        warehouse_code: this.warehouse_code,
        warehouseType: this.warehouseType,
        batchCurrency: this.batchCurrency,
      }
      let data = JSON.stringify(this.formData)
      localStorage.setItem('purchaseFormdata', data)
      this.$router.push('/addPurchase')
      // let routeData = this.$router.resolve({
      //   path: '/addPurchase',
      // })
      // window.open(routeData.href, '_blank')
    },
    showPriceAdjustmentModal() {
      this.priceAdjustmentVisible = true
      this.priceAdjustmentData = deepClone(this.tableData)
    },
    async updatePurchaseOrderPrice() {
      this.priceAdjustmentLoading = true
      await http({
        url: api.updatePurchaseOrderPrice,
        data: {
          purchaseOrderId: this.$route.query.id,
          items: this.priceAdjustmentData.map((item) => ({
            barcode: item.barcode,
            purchaseUnitPrice: item.purchaseUnitPrice,
          })),
        },
      })
      this.$message.success(this.$t('操作成功'))
      this.priceAdjustmentVisible = false
      this.priceAdjustmentLoading = false
      this.getDetailInfo()
    },
    generateUnitConversions(unitList) {
      const conversions = []
      unitList.forEach((unit) => {
        unitList.forEach((otherUnit) => {
          if (unit.conversionRate > otherUnit.conversionRate) {
            const conversion = `${unit.conversionRate / otherUnit.conversionRate}${
              otherUnit.unitNameFull
            }/${unit.unitNameFull}`
            conversions.push(conversion)
          }
        })
      })
      return conversions.join('<br />')
    },
    selectedWarehouse(data) {
      this.warehouse_code = data.code
      this.warehouseType = data.type
      this.wmsAppCode = data.wmsAppCode
      this.formData.warehouseCode = data.uniqueCode
    },
    addPaymentPlan({ ratio, amount, due_date, index }) {
      let payableRatio = '',
        payableAmount = '',
        dueDate = '',
        amountWithoutTax = ''
      if (ratio) {
        payableRatio = ratio
        payableAmount = this.getAmountByRatio(ratio)
        amountWithoutTax = this.getAmountByRatio(ratio, this.formData.orderAmount)
      } else if (amount) {
        payableAmount = amount
        payableRatio = this.getRatioByAmount(amount)
        amountWithoutTax = this.getRatioByAmount(amount, this.formData.orderAmount)
      }
      if (due_date) {
        dueDate = due_date
      }

      let taxRate = this.formData.vatRate,
        taxAmount = ''
      if (amountWithoutTax) {
        taxAmount = this.getAmountByRatio(taxRate, amountWithoutTax)
      }
      const data = {
        isPrepay: false,
        dueDate,
        payableRatio,
        payableAmount,
        taxRate,
        taxAmount,
        amountWithoutTax,
      }
      if (index !== undefined) {
        this.paymentPlanList.splice(index, 0, data)
      } else {
        this.paymentPlanList.push(data)
      }
      this.scrollToBottom()
    },
    deletePaymentPlan(index) {
      this.paymentPlanList.splice(index, 1)
    },
    chooseDueDate(record, data) {
      record.dueDate = data.data
    },
    getAmountByRatio(ratio, amount) {
      amount = amount || this.formData.totalAmount
      return (multiply(amount, ratio) / 100).toFixed(4)
    },
    getRatioByAmount(rate, amount) {
      amount = amount || this.formData.totalAmount
      return (divide(rate, amount) * 100).toFixed(4)
    },
    calPaymentPlan() {
      if (this.paymentPlanList.length === 0) {
        this.addPaymentPlan({ ratio: 100 })
      } else {
        this.paymentPlanList.forEach((item) => {
          if (this.byPercent) {
            if (item.payableRatio) {
              item.payableAmount = this.getAmountByRatio(item.payableRatio)
            }
          } else if (item.payableAmount) {
            item.payableRatio = this.getRatioByAmount(item.payableAmount)
          }
          if (item.payableRatio) {
            item.amountWithoutTax = this.getAmountByRatio(
              item.payableRatio,
              this.formData.orderAmount
            )
          }
        })
        this.calcPaymentPlanTax()
      }
    },
    checkLessPercent(record, index) {
      if (!record.payableRatio) return
      let totalPercent = 0
      if (record.payableRatio > 100) {
        record.payableRatio = 100
        record.payableAmount = this.formData.totalAmount
      }
      record.payableAmount = this.getAmountByRatio(record.payableRatio)

      this.paymentPlanList.forEach((item) => {
        totalPercent = add(totalPercent, +item.payableRatio)
      })
      if (totalPercent > 100) {
        this.$message.error(this.$t('应付比例总和不允许大于100%'))
      } else if (totalPercent < 100) {
        this.addPaymentPlan({
          ratio: subtract(100, totalPercent),
          due_date: record.dueDate,
          index: index + 1,
        })
        this.$nextTick(() => {
          this.calPaymentPlan()
        })
      }
    },
    checkLessAmount(record, index) {
      if (!record.payableAmount) return
      let totalAmount = 0
      record.payableRatio = this.getRatioByAmount(record.payableAmount)

      this.paymentPlanList.forEach((item) => {
        totalAmount = add(totalAmount, +item.payableAmount)
      })

      if (totalAmount > this.formData.totalAmount) {
        this.$message.error(this.$t('应付金额总和不允许大于订单总金额'))
      } else if (totalAmount < this.formData.totalAmount) {
        this.addPaymentPlan({
          amount: subtract(this.formData.totalAmount, totalAmount),
          due_date: record.dueDate,
          index: index + 1,
        })
        this.$nextTick(() => {
          this.calPaymentPlan()
        })
      }
    },
    calcPaymentPlanTax() {
      this.paymentPlanList.forEach((item) => {
        item.taxRate = this.formData.vatRate
        if (item.amountWithoutTax) {
          item.taxAmount = this.getAmountByRatio(item.taxRate, item.amountWithoutTax)
        }
      })
    },
    goToSupplierDetail() {
      this.$router.push({
        name: 'addSupplier',
        query: { id: this.formData.supplierCode, from: 'addPurchase' },
      })
      this.supplierVisible = false
      this.$refs.selectSupplierRef.clear()
    },
    changeShipper(data) {
      if (!this.formData.businessUnitCode) {
        //调用接口去拿仓库货主对应的结算组织
        http({
          url: api.queryWarehousePageWithShipper,
          data: {
            merchantCode: localStorage.getItem('merchantCode'),
            wmsAppCode: this.wmsAppCode,
            shipperCode: data.shipperCode,
            warehouseCode: this.warehouse_code,
            status: true,
          },
          success: (res) => {
            let list = res.result.list || []
            this.formData.businessUnitCode = list[0]?.settlementBuCode
            this.formData.businessUnitName = list[0]?.settlementBuName
          },
        })
      }
    },
    handleChangeAllCurrency(value) {
      this.tableData.forEach((item) => {
        item.currency = value
      })
    },
    onSkuSelected(val) {
      console.log(val)
      const skuStyleValue = Object.values(val.selectedSpecs)
      const obj = {
        ...val,
        barcode: val.skuCode,
        skuStyleValue: skuStyleValue.join(','), //按颜色、运行内存、机身存储、成新 拼接
      }
      obj.skuName = obj.modelName + '-' + skuStyleValue.join(' ')
      this.currentGood = obj
      this.addGoodsToTable()
    },
  },
}
</script>

<style lang="scss" scoped>
.statusBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-table-heard:before {
  content: '*';
  color: red;
}

.form-content {
  padding: 20px 5%;
}
.ant-form-item {
  margin-bottom: 0;
}
.search-group {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  .add {
    position: absolute;
    display: block;
    right: -45px;
  }
}
.goods-list {
  flex-wrap: wrap;
  .goods-item {
    line-height: normal;
    margin-right: 6px;
    margin-bottom: 4px;
    white-space: nowrap;
  }
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fixContent {
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 0;
  padding-left: 0;
}
.node-modal {
  font-size: 15px;
  padding-top: 10px;
  text-align: center;
}
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.right-div {
  background-color: transparent;
  font-size: 12px;
  width: 300px;
  height: 591px;
  overflow: auto;
}
.formContentGoods {
  /* padding: 10px 15px; */
  margin-bottom: 16px;
  background-color: white;
  color: #333333;
  font-size: 14px;
}
.modalA :deep(.ant-modal-footer) {
  border-top: 0px solid #e8e8e8;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
.inputMody {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
  outline: none;
}
.inputMody::-webkit-input-placeholder {
  color: #ccc;
}
.pricing-method {
  margin-bottom: 10px;
}
.create-batch-check-order-job :deep(.ant-tabs-bar) {
  margin-bottom: 0;
}
</style>
